import { useEffect } from "react";
import type { ReactElement } from "react";
import { FinancialIndicatorsCard } from "./card";
import { FinancialIndicatorsNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { FinancialIndicatorsTable } from "./table";

export default function FinancialIndicator(): ReactElement {
  useEffect(() => {
    setDocumentTitle("Quantilia | Indicateurs financiers");
  }, []);

  return (
    <Routes>
      <Route index element={<FinancialIndicatorsTable />} />
      <Route path="/new" element={<FinancialIndicatorsNew />} />
      <Route path=":id" element={<FinancialIndicatorsCard />} />
    </Routes>
  );
}
